import styled from 'styled-components';

import { AuthTypeMap } from '@components/integrations';
import { Authentication } from '@components/integrations/integrations-types';
import { useScopedTranslate } from '@locale/translate';
import { theme } from '@styles/theme';

const SuffixText = styled.span({
  color: theme.color.textHelper,
});

const locale = {
  en: {
    default: '(Default)',
    advanced: '(Advanced)',
  },
};

type AuthLabelProps = {
  authType: Authentication['authType'];
  authentications: { authType: string }[];
};

export const AuthLabel = ({ authType, authentications }: AuthLabelProps) => {
  const { t } = useScopedTranslate(locale);
  const hasOAuthConnect = authentications.some((a) => a.authType === 'oauth_connect');

  if (authType === 'oauth_connect') {
    return (
      <span>
        {AuthTypeMap[authType]} <SuffixText>{t('default')}</SuffixText>
      </span>
    );
  }

  if (hasOAuthConnect) {
    return (
      <span>
        {AuthTypeMap[authType] ?? authType} <SuffixText>{t('advanced')}</SuffixText>
      </span>
    );
  }

  return <>{AuthTypeMap[authType] ?? authType}</>;
};

export const sortAuthenticationsWithOAuthFirst = <T extends { authType: string }>(
  auths: T[]
): T[] => {
  return [...auths].sort((a, b) => {
    if (a.authType === 'oauth_connect') return -1;
    if (b.authType === 'oauth_connect') return 1;
    return 0;
  });
};
